import React from "react";
import {
  btnStyle,
  managementInputStyle,
  managementModalStyle,
  StyledModal,
} from "pages/PatientOverview/styles";
import { Box, Button, CircularProgress, Grid, TextField } from "@mui/material";
import { icons } from "constants/icons";
import { InviteResultModal } from "pages/auth/InviteResultModal";
import { useValidEmail } from "hooks/useValidEmail";
import { ClinicRepository } from "repositories/ClinicRepository";

type Props = {
  isEnabled: boolean;
  setIsEnabled: any;
  patientId: string;
  firstName: string;
  lastName: string;
};

export const AddCoachToAthleteModal = ({
  isEnabled,
  setIsEnabled,
  patientId,
  firstName,
  lastName,
}: Props) => {
  const [open, setOpen] = React.useState(false);
  const [isError, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const {
    email: coachEmail,
    setEmail: setCoachEmail,
    emailIsValid: coachEmailIsValid,
  } = useValidEmail("");

  const handleAssignCoach = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    if (isError) {
      setError("");
    }
    if (!coachEmail) {
      setError("Enter coach email");
    }
    try {
      const clinicianRepository = ClinicRepository.getInstance();
      const requestBody = {
        clinicianEmail: coachEmail || "",
        patientId,
      };
      await clinicianRepository.assignAthleteToCoach(requestBody);
      setOpen(true);
    } catch (error: any) {
      setError(error.response.data);
    }

    setLoading(false);
  };

  const onCloseResultModal = () => {
    setOpen(false);
    setIsEnabled(false);
  };

  return (
    <StyledModal
      onClick={(e) => {
        e.stopPropagation();
      }}
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={isEnabled}
    >
      <Box sx={managementModalStyle}>
        <>
          <Grid container mt={1} mb={1}>
            <Grid item xs={11} sx={{ fontWeight: "700", fontSize: 16 }}>
              {"Assign to another coach "}
            </Grid>
            <Grid item xs={1}>
              <img
                aria-hidden="true"
                src={icons.modalClose}
                alt="close"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setIsEnabled(false);
                }}
              />
            </Grid>
          </Grid>
          <Grid container mb={2}>
            <Grid item xs={12} sx={{ fontSize: 12, fontWeight: "400" }}>
              Enter the coach email below.
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                variant="standard"
                placeholder="Enter Email"
                fullWidth
                required
                style={managementInputStyle}
                InputProps={{
                  disableUnderline: true,
                  style: { color: "#5C5D68" },
                }}
                onChange={(e: any) => {
                  if (isError) {
                    setError("");
                  }
                  setCoachEmail(e.target.value);
                }}
              />
            </Grid>

            {isError && (
              <Grid
                item
                xs={12}
                sx={{ fontSize: 12, fontWeight: "400", color: "red" }}
              >
                {isError}
              </Grid>
            )}

            <Grid container xs={12} justifyContent="flex-end" mt={3}>
              <Grid item>
                {loading ? (
                  <CircularProgress size={20} />
                ) : (
                  <Button
                    title="Send Invite"
                    type="submit"
                    disabled={coachEmailIsValid != ""}
                    color="primary"
                    variant="contained"
                    style={btnStyle}
                    onClick={(e) => {
                      handleAssignCoach(e);
                    }}
                  >
                    Assign
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
          <InviteResultModal
            open={open}
            extraWidth={true}
            successMessage={`Patient ${firstName} ${lastName} was successfully assigned to ${coachEmail} coach`}
            onCloseResultModal={onCloseResultModal}
            isError={Boolean(isError)}
          />
        </>
      </Box>
    </StyledModal>
  );
};
